var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { obterBoleto } from "../../services/veiculos.service";
import { Colors } from "../../util/theme";
import { FormButton, FormButtonType } from "../FormButton";
import { Modal } from "../Modal";
import { SnackbarFeedback } from "../SnackbarFeedback";
import { ViewPdf } from "../ViewPdf";
export var EmitirTodosBoletos = function (_a) {
    var debts = _a.debts, plate = _a.plate;
    var userInfo = useAuth().userInfo;
    var _b = useState(false), modalAllDebts = _b[0], setModalAllDebts = _b[1];
    var _c = useState(undefined), base64 = _c[0], setBase64 = _c[1];
    var _d = useState(), erro = _d[0], setErro = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var listIdDebts = debts.map(function (debt) { return debt.idDebito; }).toString();
    var getAllDebts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    setLoading(true);
                    setErro(undefined);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, 4, 5]);
                    payload = {
                        cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        placa: plate !== null && plate !== void 0 ? plate : "",
                        listaIdDebito: listIdDebts,
                    };
                    return [4 /*yield*/, obterBoleto(payload)];
                case 2:
                    response = _f.sent();
                    setBase64(response.pdf);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _f.sent();
                    console.log((_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno);
                    setErro((_e = (_d = (_c = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.MensagemRetorno) !== null && _e !== void 0 ? _e : "Erro ao gerar boleto");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    setModalAllDebts(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs(Button, __assign({ onClick: function () { return setModalAllDebts(true); }, sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                } }, { children: [_jsxs(Box, __assign({ display: "flex", alignItems: "center", gap: "1rem" }, { children: [_jsx(ChecklistOutlinedIcon, { fontSize: "large", sx: { color: Colors.AZUL_GOV } }), _jsxs(Box, __assign({ display: "flex", flexDirection: "column", alignItems: "start" }, { children: [_jsx(Typography, __assign({ mt: 1, fontSize: "1rem", fontWeight: 500, sx: { color: "black" } }, { children: "Emitir Todos" })), _jsx(Typography, __assign({ variant: "caption", color: "textSecondary", textAlign: "start" }, { children: "Realize a Emiss\u00E3o de todos os D\u00E9bitos do Ve\u00EDculo." }))] }))] })), _jsx(IconButton, __assign({ onClick: function () { return null; } }, { children: _jsx(ArrowForwardIosOutlinedIcon, { sx: { color: "#757575" } }) }))] })), _jsx(Modal, __assign({ open: modalAllDebts, onClose: function () { return setModalAllDebts(false); }, icon: _jsx(Stack, __assign({ bgcolor: Colors.AZUL_GOV, borderRadius: "50%", p: "0.5rem" }, { children: _jsx(ChecklistOutlinedIcon, { sx: { color: "white" } }) })), title: "Emitir todos os d\u00E9bitos?", directionButtons: "row-reverse", buttons: [
                    _jsx(FormButton, { onClick: getAllDebts, title: "Confirmar", type: FormButtonType.PRIMARY, isLoading: loading, isDisabled: loading }, 0),
                    _jsx(FormButton, { onClick: function () { return setModalAllDebts(false); }, title: "Cancelar", type: FormButtonType.SECONDARY, isDisabled: loading }, 1),
                ] }, { children: debts === null || debts === void 0 ? void 0 : debts.map(function (debito) {
                    var _a;
                    return (_jsxs(Typography, __assign({ variant: "body1", color: "textSecondary" }, { children: ["- ", (_a = debito.descricaoClasse) !== null && _a !== void 0 ? _a : debito.descricaoReduzida, " ", debito.exercicio, " - R$", " ", parseFloat(debito.valorVencimento).toFixed(2)] }), debito.idDebito));
                }) })), base64 && (_jsx(ViewPdf, { isOpen: !!base64, close: function () { return setBase64(undefined); }, base64: base64, title: "D\u00E9bitos" })), erro && _jsx(SnackbarFeedback, { isOpen: !!erro, message: erro, type: "error" })] }));
};
